const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const formatMessage = require('format-message');
const axios = require('axios');
const codeGeneration = require('../codeGeneration');

let setupCode = '';
let loopCode = '';
let defineCode = '';
let bodyCode = '';
let codeContext = 'setup';
let initializedPins = new Set();
let definedFunctions = new Set();
let declaredVars = new Set();

class Esp32Blocks {
    constructor(runtime) {
        this.runtime = runtime;
        this.definedVariables = new Set();
        this.latestSerialLine = '';
        this.newSerialLineReceived = false;
        this.lastThread = null;

        if (runtime) {
            runtime.on('ESP32_SERIAL_LINE', line => {
                this.latestSerialLine = line;
                this.newSerialLineReceived = true;

                console.log('[VM] Serial line:', line);
            });
            runtime.on('PROJECT_RUN_START', () => {
                codeGeneration.onRunStart();
            });
            runtime.on('PROJECT_RUN_STOP', () => {
                codeGeneration.onRunStop();
            });
        }
        codeContext = localStorage.getItem('codeContext') || 'setup';
        codeContext = localStorage.setItem('codeContext', 'setup');
    }

    _checkNewThread(util) {
        const thread = util && util.thread;
        if (thread && this.lastThread !== thread) {
            this.lastThread = thread;
            this.definedVariables.clear();
            definedFunctions.clear();
            initializedPins.clear();
            declaredVars.clear();
        }
    }

    getInfo() {
        return {
            id: 'esp32',
            color1: '#AF7AC5',
            name: formatMessage({
                id: 'esp32.categoryName',
                default: 'ESP32',
                description: 'ESP32 extension category'
            }),
            blocks: [
                {
                    opcode: 'includeHeader',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'esp32.includeHeader',
                        default: 'Include header [headerFile]',
                        description: 'Include a header file'
                    }),
                    arguments: {
                        headerFile: {
                            type: ArgumentType.STRING,
                            menu: 'headerMenu',
                            defaultValue: 'Wire.h'
                        }
                    }
                },
                {
                    opcode: 'setCodeContext',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'roboticarm.setCodeContext',
                        default: 'call the fuction inside [context]',
                        description: 'Set whether to add code to setup or loop section.'
                    }),
                    arguments: {
                        context: {
                            type: ArgumentType.STRING,
                            menu: 'contextMenu',
                            defaultValue: 'setup'
                        }
                    },
                    func: 'setCodeContext'
                },
                {
                    opcode: 'ifBlock',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'arduinouno.ifBlock',
                        default: 'If [condition] then execute',
                        description: 'Evaluate condition and execute code'
                    }),
                    arguments: {
                        condition: {
                            type: ArgumentType.BOOLEAN,
                            defaultValue: true
                        }
                    }
                },
                {
                    opcode: 'elseifBlock',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'arduinouno.elseifBlock',
                        default: 'else if [condition] then execute',
                        description: 'Evaluate condition and execute code'
                    }),
                    arguments: {
                        condition: {
                            type: ArgumentType.BOOLEAN,
                            defaultValue: true
                        }
                    }
                },
                {
                    opcode: 'elseBlock',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'arduinouno.elseBlock',
                        default: 'else then execute',
                        description: 'Evaluate condition and execute code'
                    })
                },
                {
                    opcode: 'closeBlock',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'arduinouno.closeBlock',
                        default: 'Close the condition block',
                        description: 'Close the condition block'
                    })
                },
                {
                    opcode: 'setSerialBaudRate',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'arduinouno.setSerialBaudRate',
                        default: 'Set serial baud rate to [baudrate]',
                        description: 'Set the baud rate for serial communication'
                    }),
                    arguments: {
                        baudrate: {
                            type: ArgumentType.STRING,
                            menu: 'baudrateMenu',
                            defaultValue: '9600'
                        }
                    }
                },
                {
                    opcode: 'readSerialValue',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'arduinouno.readSerialValue',
                        default: 'Read Serial value',
                        description: 'Read serial value from defined serial port'
                    })
                },
                {
                    opcode: 'storeSerialValue',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'arduinouno.storeSerialValue',
                        default: 'Store the serial value as [datatype]',
                        description: 'Read serial value from defined serial port'
                    }),
                    arguments: {
                        datatype: {
                            type: ArgumentType.STRING,
                            menu: 'datatypeMenu',
                            defaultValue: 'int'
                        }
                    }
                },
                {
                    opcode: 'getLatestSerialLine',
                    blockType: BlockType.REPORTER,
                    text: 'latest serial line'
                },
                {
                    opcode: 'PrintNewSerialLine',
                    blockType: BlockType.COMMAND,
                    text: 'print new serial line with value [stringValue]',
                    arguments: {
                        stringValue: {
                            type: ArgumentType.STRING,
                            defaultValue: '"Hello World"'
                        }
                    }
                },
                {
                    opcode: 'printLabelAndVar',
                    blockType: BlockType.COMMAND,
                    text: 'print [label] value of [varName]',
                    arguments: {
                        label: {
                            type: ArgumentType.STRING,
                            defaultValue: '"String"'
                        },
                        varName: {
                            type: ArgumentType.STRING,
                            defaultValue: 'Value'
                        }
                    }
                },
                {
                    opcode: 'declareVar',
                    blockType: BlockType.COMMAND,
                    text: 'declare [datatype] variable [varName] = [initValue]',
                    arguments: {
                        datatype: {
                            type: ArgumentType.STRING,
                            menu: 'datatypeMenu',
                            defaultValue: 'int'
                        },
                        varName: {
                            type: ArgumentType.STRING,
                            defaultValue: 'myVar'
                        },
                        initValue: {
                            type: ArgumentType.STRING,
                            defaultValue: '0'
                        }
                    }
                },
                {
                    opcode: 'setVar',
                    blockType: BlockType.COMMAND,
                    text: 'set variable [varName] = [value]',
                    arguments: {
                        varName: {
                            type: ArgumentType.STRING,
                            defaultValue: 'myVar'
                        },
                        value: {
                            type: ArgumentType.STRING,
                            defaultValue: '0'
                        }
                    }
                },
                {
                    opcode: 'getVar',
                    blockType: BlockType.REPORTER,
                    text: 'variable [varName]',
                    arguments: {
                        varName: {
                            type: ArgumentType.STRING,
                            defaultValue: 'myVar'
                        }
                    }
                },
            ],
            menus: {
                digitalPortMenu: {
                    items: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13']
                },
                ipopMenu: {
                    items: ['OUTPUT', 'INPUT']
                },
                onoffMenu1: {
                    items: ['ACTIVE', 'INACTIVE']
                },
                varMenu1: {
                    items: ['m1a', 'm1b', 'm2a', 'm2b']
                },
                headerMenu: {
                    items: ['Wire.h', 'SPI.h', 'Adafruit_PWMServoDriver.h', 'Adafruit_GFX.h', 'Adafruit_SSD1306.h', 'ESP32Servo.h']
                },
                varMenu2: {
                    acceptReporters: true,
                    items: ['v1', 'v2', 'v3', 'v4']
                },
                numMenu1: {
                    items: ['1', '2', '3', '4']
                },
                numMenu2: {
                    items: ['1', '2', '3', '4']
                },
                numMenu3: {
                    items: ['5', '6', '7', '8', '9', '10', '11', '12']
                },
                dirMenu: {
                    items: ['forward', 'backward']
                },
                stateMenu: {
                    items: ['free', 'hold']
                },
                onoffMenu2: {
                    items: ['ON', 'OFF']
                },
                contextMenu: {
                    items: ['setup', 'loop']
                },
                baudrateMenu: {
                    items: ['300', '1200', '2400', '4800', '9600', '19200', '38400', '57600', '115200', '230400', '250000', '500000', '1000000', '2000000']
                },
                datatypeMenu: {
                    items: ['int', 'float', 'char', 'long', 'double']
                }
            }
        };
    }

    accumulateCode(util) {
        codeGeneration.accumulateCode(defineCode, bodyCode, setupCode, loopCode, util);
    }

    // Add this method to clear loopCode
    clearLoopCode() {
        loopCode = '';
    }


    resetCode() {
        setupCode = '';
        loopCode = '';
        defineCode = '';
        bodyCode = '';
    }

    full_reset() {
        console.log("initializedPins", initializedPins);
        setupCode = '';
        loopCode = '';
        defineCode = '';
        bodyCode = '';
        this.clearLoopCode();
        this.definedVariables.clear();
        definedFunctions.clear();
        initializedPins.clear();
        declaredVars.clear();
    }

    setSerialBaudRate(args, util) {
        this._checkNewThread(util);
        const baudrate = args.baudrate;
        codeGeneration.setSerialBaudRate(baudrate);
        setupCode += `Serial.begin(${baudrate});\n`;
        this.accumulateCode(util);
        this.resetCode();
    }

    includeHeader(args, util) {
        this._checkNewThread(util);
        const headerFile = args.headerFile;
        const codetoadd = `#include <${headerFile}>\n`;
        if (headerFile === 'Adafruit_PWMServoDriver.h') {
            defineCode += `#include <Adafruit_PWMServoDriver.h>

#define PCA9685_ADDR 0x40 // I2C address of PCA9685 module
Adafruit_PWMServoDriver pwm = Adafruit_PWMServoDriver(PCA9685_ADDR);\n`;
            setupCode += `  pwm.begin();\n  pwm.setPWMFreq(60);\n`;
        } else {
            defineCode += codetoadd;
        }
        this.accumulateCode(util);
        this.resetCode();
    }
    readSerialValue(args, util) {
        this._checkNewThread(util);
        bodyCode += `int serial_val(){\n    if (Serial.available()>0){\n        int val = Serial.read();\n        return val;\n    }\n    return 0;\n}\n`;
        this.accumulateCode(util);
        this.resetCode();
    }
    storeSerialValue(args, util) {
        this._checkNewThread(util);
        const datatype = args.datatype;  // Get the selected data type
        const codeToAdd = `${datatype} val = serial_val();\n`;  // Use the selected datatype

        if (localStorage.getItem('codeContext') === 'setup') {
            setupCode += codeToAdd;
        } else if (localStorage.getItem('codeContext') === 'loop') {
            loopCode += codeToAdd;
        }

        this.accumulateCode(util);
        this.resetCode();
    }
    ifBlock(args, util) {
        this._checkNewThread(util);
        const condi = args.condition
        if (localStorage.getItem('codeContext') === 'setup') {
            setupCode += `if(${condi}){\n`;
        }
        else if (localStorage.getItem('codeContext') === 'loop') {
            loopCode += `if(${condi}){\n`;
        }
        this.accumulateCode(util);
        this.resetCode();
    }
    elseifBlock(args, util) {
        this._checkNewThread(util);
        const condi = args.condition
        if (localStorage.getItem('codeContext') === 'setup') {
            setupCode += `}else if(${condi}){\n`;
        }
        else if (localStorage.getItem('codeContext') === 'loop') {
            loopCode += `}else if(${condi}){\n`;
        }
        this.accumulateCode(util);
        this.resetCode();
    }
    elseBlock(args, util) {
        this._checkNewThread(util);
        if (localStorage.getItem('codeContext') === 'setup') {
            setupCode += `}else{\n`;
        }
        else if (localStorage.getItem('codeContext') === 'loop') {
            loopCode += `}else{\n`;
        }
        this.accumulateCode(util);
        this.resetCode();
    }
    closeBlock(args, util) {
        this._checkNewThread(util);
        if (localStorage.getItem('codeContext') === 'setup') {
            setupCode += `}`;
        }
        else if (localStorage.getItem('codeContext') === 'loop') {
            loopCode += `}`;
        }
        this.accumulateCode(util);
        this.resetCode();
    }
    getLatestSerialLine() {
        return this.latestSerialLine;
    }
    PrintNewSerialLine(args, util) {
        this._checkNewThread(util);
        const value = args.stringValue;

        const codeToAdd = `Serial.println(${value});\n`;

        if (localStorage.getItem('codeContext') === 'setup') {
            setupCode += codeToAdd;
        } else if (localStorage.getItem('codeContext') === 'loop') {
            loopCode += codeToAdd;
        }

        this.accumulateCode(util);
        this.resetCode();
    }
    printLabelAndVar(args, util) {
        this._checkNewThread(util);
        const codeToAdd =
            `Serial.print(${args.label});\n` +
            `Serial.println(${args.varName});\n`;

        if (localStorage.getItem('codeContext') === 'setup') {
            setupCode += codeToAdd;
        } else {
            loopCode += codeToAdd;
        }

        this.accumulateCode(util);
        this.resetCode();
    }
    setCodeContext(args, util) {
        this._checkNewThread(util);
        const context = args.context;

        localStorage.setItem('codeContext', context);

        this.accumulateCode(util);
        this.resetCode();
    }
    declareVar(args, util) {
        this._checkNewThread(util);
        const datatype = args.datatype;
        const varName = args.varName.trim();
        const initValue = args.initValue;

        defineCode += `${datatype} ${varName} = ${initValue};\n`;

        this.accumulateCode(util);
        this.resetCode();
    }
    setVar(args, util) {
        this._checkNewThread(util);
        const varName = args.varName.trim();
        const value = args.value;

        const codeToAdd = `${varName} = ${value};\n`;

        if (localStorage.getItem('codeContext') === 'setup') {
            setupCode += codeToAdd;
        } else if (localStorage.getItem('codeContext') === 'loop') {
            loopCode += codeToAdd;
        }

        this.accumulateCode(util);
        this.resetCode();
    }
    getVar(args) {
        return args.varName.trim();
    }
}

module.exports = Esp32Blocks;
